module.exports = __webpack_public_path__ + "static/media/line.cf35b19a.svg";